/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_All_SubscriptionsInputs */

const en_admin_subscriptions_all_subscriptions = /** @type {(inputs: Admin_Subscriptions_All_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Subscriptions`)
};

const zh_admin_subscriptions_all_subscriptions = /** @type {(inputs: Admin_Subscriptions_All_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有订阅`)
};

/**
* | output |
* | --- |
* | "All Subscriptions" |
*
* @param {Admin_Subscriptions_All_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_all_subscriptions = /** @type {((inputs?: Admin_Subscriptions_All_SubscriptionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_All_SubscriptionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_all_subscriptions(inputs)
	return zh_admin_subscriptions_all_subscriptions(inputs)
});
export { admin_subscriptions_all_subscriptions as "admin.subscriptions.all_subscriptions" }